"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgSlack = function SvgSlack(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M21.5 25c1.382 0 2.5 1.118 2.5 2.5v5c0 1.382-1.118 2.5-2.5 2.5a2.498 2.498 0 01-2.5-2.5v-5c0-1.382 1.118-2.5 2.5-2.5zm6 5c1.382 0 2.5 1.118 2.5 2.5S28.882 35 27.5 35a2.498 2.498 0 01-2.5-2.5V31a1 1 0 011-1zm-6-3c-.278 0-.5.222-.5.5v5c0 .278.222.5.5.5s.5-.222.5-.5v-5c0-.278-.222-.5-.5-.5zm6 5H27v.5c0 .278.222.5.5.5s.5-.222.5-.5-.222-.5-.5-.5zM17 25a1 1 0 011 1v1.5c0 1.382-1.118 2.5-2.5 2.5a2.498 2.498 0 01-2.5-2.5c0-1.382 1.118-2.5 2.5-2.5H17zm15.5-1c1.382 0 2.5 1.118 2.5 2.5S33.882 29 32.5 29h-5a2.498 2.498 0 01-2.5-2.5c0-1.382 1.118-2.5 2.5-2.5h5zM16 27h-.5c-.278 0-.5.222-.5.5s.222.5.5.5.5-.222.5-.5V27zm16.5-1h-5c-.278 0-.5.222-.5.5s.222.5.5.5h5c.278 0 .5-.222.5-.5s-.222-.5-.5-.5zm-12-7c1.382 0 2.5 1.118 2.5 2.5S21.882 24 20.5 24h-5a2.498 2.498 0 01-2.5-2.5c0-1.382 1.118-2.5 2.5-2.5zm6-6c1.382 0 2.5 1.118 2.5 2.5v5c0 1.382-1.118 2.5-2.5 2.5a2.498 2.498 0 01-2.5-2.5v-5c0-1.382 1.118-2.5 2.5-2.5zm6 5c1.382 0 2.5 1.118 2.5 2.5S33.882 23 32.5 23H31a1 1 0 01-1-1v-1.5c0-1.382 1.118-2.5 2.5-2.5zm-12 3h-5c-.278 0-.5.222-.5.5s.222.5.5.5h5c.278 0 .5-.222.5-.5s-.222-.5-.5-.5zm6-6c-.278 0-.5.222-.5.5v5c0 .278.222.5.5.5s.5-.222.5-.5v-5c0-.278-.222-.5-.5-.5zm6 5c-.278 0-.5.222-.5.5v.5h.5c.278 0 .5-.222.5-.5s-.222-.5-.5-.5zm-12-7c1.382 0 2.5 1.118 2.5 2.5V17a1 1 0 01-1 1h-1.5a2.498 2.498 0 01-2.5-2.5c0-1.382 1.118-2.5 2.5-2.5zm0 2c-.278 0-.5.222-.5.5s.222.5.5.5h.5v-.5c0-.278-.222-.5-.5-.5z",
    id: "slack_svg__a"
  }));
};

var _default = SvgSlack;
exports["default"] = _default;